import { ACTIONS } from '_redux/actions';

const initialState = {
  content: {},
  contentLoading: true,
};

export default function events(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.EVENTS.FETCH_EVENTS:
      return {
        ...state,
        contentLoading: true,
      };

    case ACTIONS.EVENTS.FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        content: {
          ...action.payload.data,
        },
        contentLoading: false,
      };

    default:
      return state;
  }
}
